module.exports = __webpack_public_path__ + "zaw-logo-white.005d1e060da6e02e97efb2c837baba4a.png";